import { getFunctions, httpsCallable } from 'firebase/functions';
import type { VendorWorkType } from '../types';

export type SendSupplierQuoteApprovalEmailInput = {
  supplierOrgId: string;
  dealId: string;
  dealTitle?: string;
  projectNumber?: string;
  projectName?: string;
  workType: VendorWorkType;
  quoteLabel: string;
  customEmailMessage?: string;
  senderName?: string;
  submissionId?: string;
  rfqProjectId?: string;
};

export type SendSupplierQuoteApprovalEmailResult = {
  ok: boolean;
  sent: number;
  simulated?: boolean;
  skipped?: boolean;
  reason?: string;
};

export async function sendSupplierQuoteApprovalEmail(
  input: SendSupplierQuoteApprovalEmailInput,
): Promise<SendSupplierQuoteApprovalEmailResult> {
  const functions = getFunctions(undefined, 'us-central1');
  const fn = httpsCallable<SendSupplierQuoteApprovalEmailInput, SendSupplierQuoteApprovalEmailResult>(
    functions,
    'sendSupplierQuoteApprovalEmail',
  );
  const res = await fn(input);
  return res.data;
}
